import { ERROR, WARNING, SUCCESS, INFO } from './status';

// CUSTOMIZABLE COLORS
export const COLOR_MAIN_HIGHLIGHT = ((window || {}).colors || {}).MAIN_HIGHLIGHT || '#4C4D57';
export const COLOR_MAIN_HIGHLIGHT_TEXT = ((window || {}).colors || {}).MAIN_HIGHLIGHT_TEXT || '#FFFFFF';
export const COLOR_MAIN_HIGHLIGHT_TEXT_SECONDARY =
  ((window || {}).colors || {}).MAIN_HIGHLIGHT_TEXT_SECONDARY || '#B1B7C5';
export const COLOR_PRIMARY = ((window || {}).colors || {}).PRIMARY || '#8CB4C7';
export const COLOR_PRIMARY_CONTRAST = ((window || {}).colors || {}).PRIMARY_CONTRAST || '#FFFFFF';
export const COLOR_SECONDARY = ((window || {}).colors || {}).SECONDARY || '#C12907';
export const COLOR_SECONDARY_CONTRAST = ((window || {}).colors || {}).SECONDARY_CONTRAST || '#FFFFFF';
export const COLOR_WARNING = ((window || {}).colors || {}).WARNING || '#F19909';
export const COLOR_WARNING_CONTRAST = ((window || {}).colors || {}).WARNING_CONTRAST || '#FFFFFF';
export const COLOR_ERROR = ((window || {}).colors || {}).ERROR || '#C12907';
export const COLOR_ERROR_CONTRAST = ((window || {}).colors || {}).ERROR_CONTRAST || '#FFFFFF';
export const COLOR_SUCCESS = ((window || {}).colors || {}).SUCCESS || '#8CB4C7';
export const COLOR_SUCCESS_CONTRAST = ((window || {}).colors || {}).SUCCESS_CONTRAST || '#00000026';

// GLOBALS
export const WHITE = '#FFFFFF';
export const LIGHT_GREY = '#EFF1F3';
export const LIGHT_GREY_OPAQUE = '#F7F7FA80';
export const LIGHTER_GREY = '#EAEAEC';
export const DARKER_GREY = '#9597A0';
export const PRIMARY_TEXT_COLOR = '#23252F';
export const PRIMARY_LIGHT_BACKGROUND = '#EEF8F7';
export const SECONDARY_TEXT_COLOR = '#A2A6AC';
export const DISABLED_COLOR = '#00000026';

// INPUTS
export const INPUT_BACKGROUND = LIGHT_GREY;
export const INPUT_BACKGROUND_DISABLED = '#D6D6D6';

// SENSOR COMPARISON
export const TEXTAREA_BACKGROUND = LIGHT_GREY;
export const TEXTAREA_BACKGROUND_DISABLED = INPUT_BACKGROUND_DISABLED;
export const COMPARISON_CARD_BORDER = LIGHTER_GREY;
export const COMPARISON_PLACEHOLDER_CHARD_BORDER = '#D5D5D9';
export const COMPARISON_CARD_SELECTED_LIGHT = '#DEF1EE';
export const MENU_ITEM_BORDER = '#EBEBEB';

// GRAPHS
export const AXIS_LINE_COLOR = DARKER_GREY;
export const GRAPH_COMPARE_LINE_1 = '#00A4FF';
export const GRAPH_COMPARE_LINE_2 = '#10AD87';
export const GRAPH_COMPARE_LINE_3 = '#BA589F';
export const GRAPH_COMPARE_LINE_4 = '#C12907';
export const GRAPH_COMPARE_LINE_5 = '#880E4F';
export const GRAPH_COMPARE_LINE_6 = '#F19909';
export const GRAPH_BRUSH_OVERLAY_COLOR = 'rgba(0,0,0,.9)';

// MACHINE STATUS
export const MACHINE_MAINTENANCE_COLOR = '#8CB4C7';
export const MACHINE_RUNNING_COLOR = '#46AA9F';
export const MACHINE_CRITICAL_COLOR = '#C73E20';
export const MACHINE_WARNING_COLOR = '#F19909';
export const MACHINE_IDLE_COLOR = '#6D5D82';
export const MACHINE_NO_DATA_COLOR = '#D5D8DB';
export const MACHINE_FUTURE_COLOR = 'rgba(255,255,255,0)'; // invisible

export const SENSOR_OK_COLOR = '#8CB4C7';
export const SENSOR_NODATA_COLOR = '#4C4D57';
export const SENSOR_WARNING_COLOR = '#F19909';
export const SENSOR_CRITICAL_COLOR = '#C12907';

// Machine status tracked/untracked
export const MACHINE_STATUS_TRACKED_COLOR = '#8CB4C7';
export const MACHINE_STATUS_TRACKED_SECONDARY_COLOR = '#E2F0ED';
export const MACHINE_STATUS_UNTRACKED_COLOR = '#F9EAE6';
export const MACHINE_STATUS_UNTRACKED_SECONDARY_COLOR = '#CD5439';

export const EDIT_ICON_DEFAULT_COLOR = '#8CB4C7';

// NOTIFICATION COLORS
export const NOTIFICATION_COLORS = {
  [ERROR]: COLOR_ERROR,
  [WARNING]: COLOR_WARNING,
  [SUCCESS]: COLOR_SUCCESS,
  [INFO]: COLOR_PRIMARY
};

export const SNACKBAR_BACKGROUND = '#333333';
